import React from 'react';
import { FormattedMessage } from 'react-intl';

import NarrowWidth from '@/components/common/layout/NarrowWidth';

const OutdoorsyHistory = () => {
  return (
    <div className="w-full mb-12 bg-canvas-100">
      <NarrowWidth className="py-12 mx-auto">
        <h3 className="mb-4 text-2xl font-medium">Fast facts</h3>
        <div className="grid grid-cols-2 gap-12 md:grid-cols-3 lg:grid-cols-4">
          <div>
            <p className="text-xl text-gray-500 tracking">
              <span className="font-bold text-gray-900">250 million</span> miles driven by Outdoorsy{' '}
              <FormattedMessage defaultMessage="customers" id="RHpUzY" />
            </p>
          </div>
          <div>
            <p className="text-xl text-gray-500 tracking">
              <span className="font-bold text-gray-900">14+</span> countries and regions with{' '}
              <FormattedMessage defaultMessage="Outdoorsy listings" id="jaN8Kk" />
            </p>
          </div>
          <div>
            <p className="text-xl text-gray-500 tracking">
              <span className="font-bold text-gray-900">92%</span> of customers rate us 4-5/5 stars
            </p>
          </div>
          <div>
            <p className="text-xl text-gray-500 tracking">
              <span className="font-bold text-gray-900">8690+ vacation years</span> booked
            </p>
          </div>
          <div className="hidden lg:block" />
          <div>
            <p className="text-xl text-gray-500 tracking">
              <span className="font-bold text-gray-900">4800+</span> cities with RV listings
            </p>
          </div>
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <p className="text-xl text-gray-500 tracking">
              Outdoorsy carries RV and campervan inventory{' '}
              <span className="font-bold text-gray-900">more than the 7 largest RV dealers</span> in
              the world &mdash; combined.
            </p>
          </div>
        </div>
      </NarrowWidth>
    </div>
  );
};

export default OutdoorsyHistory;
